import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RenderHtmlWithBlobs from '../RenderHtmlWithBlob';

const UploadEssay = ({
  question,
  content,
  languageIndex,
  uploadedFiles,
  onUpload,
  studentResponse,
}) => {
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (typeof window?.MathJax !== 'undefined') {
      window.MathJax.typeset();
    }
  }, [question?.ItemID]);

  const studentAns = useMemo(
    () =>
      studentResponse.find(
        t =>
          t.sectionid === question.QuestionPaperSectionID &&
          t.itemId === question.ItemID,
      ),
    [question.ItemID, studentResponse],
  );

  let itemContent = '';
  if (question?.Items) {
    itemContent = question.Items;
  } else if (Array.isArray(content) && typeof languageIndex === 'number' && content[languageIndex]) {
    itemContent = content[languageIndex].split('[quizky-text]').join('');
  }

  const files = Array.isArray(uploadedFiles)
    ? uploadedFiles
    : Array.isArray(studentAns?.uploadedFiles)
      ? studentAns.uploadedFiles
      : [];

  const allowedExtensions = ['pdf'];

  const filesUI = Array.isArray(files) ? files : [];

  const validateAndNormalizeFiles = (incomingFiles) => {
    const list = Array.from(incomingFiles || []);
    const validFiles = list.filter((f) => {
      const ext = f.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(ext);
    });
    if (validFiles.length !== list.length) {
      alert(`Some files have invalid extensions. Allowed: ${allowedExtensions.join(', ')}`);
    }
    return validFiles;
  };

  const handleFilesSelected = async (incomingFiles) => {
    const validFiles = validateAndNormalizeFiles(incomingFiles);
    if (validFiles.length) {
      await onUpload(question, validFiles);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleChooseClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="type-upload-essay-wrapper">
      {itemContent && (
        <div className="qn-question">
          <RenderHtmlWithBlobs htmlString={itemContent} />
        </div>
      )}

      <div
        style={{
          border: '1px solid #ddd',
          borderRadius: 4,
          marginTop: 12,
          background: '#f9f9f9',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 80,
          padding: '12px 16px',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: 12,
          }}
        >
          <button
            type="button"
            className="mob-btn-submit"
            style={{
              background: '#2b6cb0',
              color: '#fff',
              border: '1px solid #2b6cb0',
              borderRadius: 2,
              minWidth: 100,
              padding: '8px 16px',
              fontSize: 13,
              cursor: 'pointer',
            }}
            onClick={handleChooseClick}
          >
            Choose Files
          </button>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept=".pdf"
            style={{ display: 'none' }}
            onChange={(e) => handleFilesSelected(e.target.files)}
          />

          <span style={{ color: '#888', fontSize: 14 }}>
            Select PDF files to upload automatically
          </span>
        </div>
        {studentAns?.enteredText && (
          <div
            style={{
              color: 'green',
              fontSize: 13
            }}
          >
            File is submitted.
          </div>
        )}
      </div>
    </div>
  );
};

// PropTypes and defaults unchanged
UploadEssay.propTypes = {
  question: PropTypes.object.isRequired,
  content: PropTypes.array,
  languageIndex: PropTypes.number,
  uploadedFiles: PropTypes.array,
  onUpload: PropTypes.func,
  studentResponse: PropTypes.array,
};

UploadEssay.defaultProps = {
  question: {},
  content: [],
  languageIndex: 0,
  uploadedFiles: [],
  onUpload: () => { },
  studentResponse: [],
};

const mapStateToProps = ({ engine }) => ({
  studentResponse: engine.studentResponse,
});

export default connect(mapStateToProps)(UploadEssay);